@charset "UTF-8";

/* src/app/modules/print-cards/components/cards/card-content/business-cards-2x3/harlequin-business-card-stack-content/harlequin-business-card-stack-content.component.scss */
.f12px {
  font-size: 0.75rem;
}
.f14px {
  font-size: 0.875rem;
}
.f16px {
  font-size: 1rem;
}
.f18px {
  font-size: 1.125rem;
}
.f20px {
  font-size: 1.25rem;
}
.f24px {
  font-size: 1.5rem;
}
.f32px {
  font-size: 2rem;
}
.f48px {
  font-size: 3rem;
}
.f64px {
  font-size: 4rem;
}
:host {
  width: 100%;
  height: 100%;
  padding: 0.5rem 0.5rem 0.375rem 0.5rem;
  box-sizing: border-box;
  overflow: hidden;
  --badge-grid-min-col: 1rem;
}
:host .main-content {
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  height: 100%;
  width: 100%;
}
:host .main-content .left-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 5rem;
}
:host .main-content .left-container .logo-container .brand-logo {
  max-height: 100%;
  max-width: 5rem;
}
:host .main-content .left-container .logo-container .product-card-brand {
  font-family: poppins, sans-serif;
  font-weight: 700;
  font-size: 1.5rem;
}
:host .main-content .right-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1;
  padding-left: 0.5rem;
}
:host .main-content .right-container .top-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 3.8125rem;
}
:host .main-content .right-container .top-container .product-card-strain-type {
  font-family: poppins, sans-serif;
  font-weight: 600;
  font-size: 0.625rem;
  background-color: #6992eb;
  color: #ffffff;
  border-radius: 0.125rem;
  padding: 0.0625rem 0.25rem;
  margin-left: auto;
  width: fit-content;
}
:host .main-content .right-container .top-container .product-name-badges-and-label-container {
  display: flex;
  flex-direction: column;
}
:host .main-content .right-container .top-container .product-name-badges-and-label-container .product-card-name {
  font-family: poppins, sans-serif;
  font-weight: 600;
  font-size: 1rem;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  width: 11rem;
  line-height: 1rem;
  padding-bottom: 0.25rem;
}
:host .main-content .right-container .top-container .product-name-badges-and-label-container .badge-and-label-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 0.8125rem;
  gap: 0.3125rem;
}
:host .main-content .right-container .top-container .product-name-badges-and-label-container .badge-and-label-container .badge-container {
  display: flex;
  flex-direction: row;
  gap: 0.125rem;
}
:host .main-content .right-container .top-container .product-name-badges-and-label-container .badge-and-label-container .badge-container .badge {
  width: 1rem;
  height: 1rem;
}
:host .main-content .right-container .top-container .product-name-badges-and-label-container .badge-and-label-container .print-card-label {
  height: fit-content;
  margin: 0;
  padding: 0;
}
:host .main-content .right-container .top-container .product-name-badges-and-label-container .badge-and-label-container .print-card-label ::ng-deep .product-label {
  font-family: poppins, sans-serif;
  font-weight: 600;
  font-size: 0.5rem;
  display: -webkit-box;
  border-radius: 0.125rem;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: unset;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  word-break: break-all;
  margin-left: 0;
  padding: 0 0.3125rem;
}
:host .main-content .right-container .bottom-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
}
:host .main-content .right-container .bottom-container .property-column {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-start;
  min-width: 0;
}
:host .main-content .right-container .bottom-container .property-column .property-container {
  display: flex;
  flex-direction: row;
  align-items: center;
}
:host .main-content .right-container .bottom-container .property-column .property-container .title {
  font-family: poppins, sans-serif;
  font-weight: 700;
  font-size: 0.5625rem;
  opacity: 0.4;
  width: 1.875rem;
  line-height: 120%;
}
:host .main-content .right-container .bottom-container .property-column .property-container .value {
  overflow-x: clip;
  min-width: 0;
  line-height: 102%;
  font-family: poppins, sans-serif;
  font-weight: 600;
  font-size: 0.75rem;
}
:host .main-content .right-container .bottom-container .size-and-price-container {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
}
:host .main-content .right-container .bottom-container .size-and-price-container .product-card-size {
  font-family: poppins, sans-serif;
  font-weight: 700;
  font-size: 0.5625rem;
  opacity: 0.4;
  line-height: 102%;
}
:host .main-content .right-container .bottom-container .size-and-price-container .pricing-container ::ng-deep .product-column-general {
  overflow-x: unset;
}
:host .main-content .right-container .bottom-container .size-and-price-container .pricing-container ::ng-deep .product-variant-price {
  display: flex;
  flex-direction: column-reverse;
  align-items: center;
  font-family: poppins, sans-serif;
  font-weight: 600;
}
:host .main-content .right-container .bottom-container .size-and-price-container .pricing-container ::ng-deep .product-variant-price .product-variant-previous-price {
  font-size: 0.625rem;
  opacity: 0.4;
  line-height: 102%;
}
:host .main-content .right-container .bottom-container .size-and-price-container .pricing-container ::ng-deep .product-variant-price .product-variant-previous-price .product-variant-price-decoration {
  font-size: 0.625rem;
}
:host .main-content .right-container .bottom-container .size-and-price-container .pricing-container ::ng-deep .product-variant-price .product-variant-current-price {
  font-size: 0.8125rem;
  line-height: 102%;
}
:host .main-content .right-container .bottom-container .size-and-price-container .pricing-container ::ng-deep .product-variant-price .product-variant-price-decoration {
  font-size: 0.8125rem;
  line-height: 102%;
}
:host .main-content ::ng-deep .force-italic-style * {
  font-family: poppins, sans-serif;
  font-style: italic;
  font-weight: 600;
}
:host .main-content ::ng-deep .force-bold-style * {
  font-family: poppins, sans-serif;
  font-weight: 700;
}
/*# sourceMappingURL=harlequin-business-card-stack-content.component.css.map */
